export default __webpack_public_path__ + "static/media/rarity-btn-special.e4b77887.svg";